import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Button from "@mui/material/Button";

import React, { useState } from "react";
import { BsBorderCenter } from "react-icons/bs";

const steps = ["", "", ""];

export default function Timeline({ activeStep,isCreditScoreCheck }) {
  // const [activeStep, setActiveStep] = useState('');
  // const handelNext = () => {

  // 	setActiveStep((prevActiveStep) => prevActiveStep + 1);
  // };
  return (
    <Box sx={{ width: "100%", marginTop: "20px",marginBottom:"-20px" }}>
      <Stepper
        activeStep={activeStep}
        // activeStep={activeStep}
        sx={{
          width: !isCreditScoreCheck?"90%":"58%",
          display: "flex",
          alignItems: "center",
          marginLeft: !isCreditScoreCheck?"30px":"90px",
          marginBottom:!isCreditScoreCheck?"0":"50px",
          // border: "1px solid red",
          justifyContent: "center",
        }}
        alternativeLabel
      >
        {steps.map((label) => (
          <Step
            sx={{
              "& .MuiStepLabel-root .Mui-completed": {
                color: "#00BA00", // circle color (COMPLETED)
              },
              "& .MuiStepLabel-label.Mui-completed.MuiStepLabel-alternativeLabel":
                {
                  color: "white", // Just text label (COMPLETED)
                },
              "& .MuiStepLabel-root .Mui-active": {
                blockSize: "30px",

                color: "#6C63FF", // circle color (ACTIVE)
                height: "24px",
                width: "24px",
                borderRadius: "12px",
              },
              "& .MuiStepLabel-label.Mui-active.MuiStepLabel-alternativeLabel":
                {
                  color: "white", // Just text label (ACTIVE)
                },
              "& .MuiStepLabel-root .Mui-active .MuiStepIcon-text": {
                fill: "white", // circle's number (ACTIVE)
              },
            }}
            key={label}
          >
            <StepLabel>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>
      {/* <Button color="inherit" sx={{ mr: 1 }}>
				Next
			</Button> */}
    </Box>
  );
}
// onClick = { handelNext };
